import { getDaysInMonth } from "date-fns";

const daysInSelectedMonth = (y,m) => {

    let dayCount = 31

    //valid month and year
    if (y !== 'Year' && !isNaN(y) && m !== 'Month' && !isNaN(m) && m > 0 && m < 13) {
        //console.log('both y and m are valid, setting dayCount to days in month')
        dayCount = getDaysInMonth(new Date(y, m-1, 1))
    } else if (y === 'Year' && m !== 'Month') {//if month is specified, but year is not
        //console.log('y is not specified but month is, getting dayCount from month and current year')
        let currentDate = new Date();
        y = currentDate.getFullYear();
        //console.log('y set to => ',y)
        dayCount = getDaysInMonth(new Date(y, m-1, 1))
    } //else {
        //console.log('cannot determine dayCount, using default dayCount 31')
        // dayCount = 31;
    //}

    const objectDaysInMonth = {};
    for (let i = 1; i <= dayCount; i++) {
        objectDaysInMonth[i] = i;
    }

    return objectDaysInMonth;
}

const dobYears = (y,r) => {//year, range
    const dobYearsObj = {};
    for (let i = y-r; i <= y; i++) {
        dobYearsObj[i] = i;
    }
    return dobYearsObj;
}

const isValidFullDate = (y,m,d) => {
    if (isNaN(y) || isNaN(m) || isNaN(d)) {
        return false
    }
    if (m < 1 || m > 12) {
        return false
    }
    if (d < 1 || d > getDaysInMonth(new Date(y, m-1, 1))) {
        return false
    }
    return true
}

export { daysInSelectedMonth, dobYears, isValidFullDate }